import type { ReactNode } from "react";
import type { U2000TableColumn } from "../../../../../../u2000Core/components/tables/basic/U2000BasicTableList";

/** Découpe « Libellé (suffixe) » sur deux lignes pour en-têtes de grille étroits. */
function splitLabelParenthesis(label: string): { primary: string; secondary: string } | null {
  const match = label.match(/^(.+?)\s+(\([^)]+\))\s*$/);
  if (!match) return null;
  return { primary: match[1].trim(), secondary: match[2].trim() };
}

/** Découpe sur le premier espace (ex. « Montant d'origine », « Solde restant »). */
function splitLabelFirstWord(label: string): { primary: string; secondary: string } | null {
  const trimmed = label.trim();
  const spaceIdx = trimmed.indexOf(" ");
  if (spaceIdx <= 0) return null;
  const primary = trimmed.slice(0, spaceIdx).trim();
  const secondary = trimmed.slice(spaceIdx + 1).trim();
  if (!primary || !secondary) return null;
  return { primary, secondary };
}

function splitLabelForTwoLineHeader(label: string): { primary: string; secondary: string } | null {
  return splitLabelParenthesis(label) ?? splitLabelFirstWord(label);
}

export function u3121BillingSummaryTwoLineHeaderDisplay(column: U2000TableColumn, label: string): ReactNode {
  const parts = splitLabelForTwoLineHeader(label);
  if (!parts) return label;

  const align = column.align ?? "left";
  const itemsClass =
    align === "right" ? "items-end text-right" : align === "center" ? "items-center text-center" : "items-start text-left";

  return (
    <span className={`inline-flex flex-col leading-tight ${itemsClass}`}>
      <span className="font-medium">{parts.primary}</span>
      <span className="text-xs font-normal text-gray-700">{parts.secondary}</span>
    </span>
  );
}

/** En-tête sur 2 lignes si le libellé est découpable (parenthèses ou premier mot). */
export function u3121BillingSummaryHeaderDisplayIfTwoLine(
  column: U2000TableColumn,
  label: string,
  _allRowSelected?: boolean,
): ReactNode {
  if (!splitLabelForTwoLineHeader(label)) return label;
  return u3121BillingSummaryTwoLineHeaderDisplay(column, label);
}
